export default __webpack_public_path__ + "static/media/calendar.96945613.png";